module.exports = __webpack_public_path__ + "img/icon_jichengbianjie.7c8dce3e.png";